import { Popover, popoverClasses } from "@mui/material";
import { styled } from "@mui/material/styles";
import { dateRangeCalendarClasses } from "@mui/x-date-pickers-pro";

export const TotalCarCare = styled("div", {
  label: "total-car-care",
})`
  display: flex;
  justify-content: space-between;
  padding-top: ${({ theme }) => theme.spacing(2)};
`;

export const DatePopover = styled(Popover, {
  label: "date-popover",
})`
  .${dateRangeCalendarClasses.root} {
    padding: ${({ theme }) => theme.spacing(0, 4, 2, 4)};
  }
  .${popoverClasses.paper} {
    border-radius: ${({ theme }) => theme.shape.borderRadius * 4}px;
  }
`;

export const DatePopoverActions = styled("div", {
  label: "date-popover-actions",
})`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid ${({ theme }) => theme.palette.color.gray[90]};
  padding: ${({ theme }) => theme.spacing(2, 4)};
`;

export const DatePopoverActionText = styled("div", {
  label: "date-popover-action-text",
})`
  color: ${({ theme }) => theme.palette.color.gray[60]};
`;
